export default class Controller {
  constructor(model, view, wrapper) {
    this.model = model;
    this.view = view;

    this.wrapper = wrapper;

    this.products = this.wrapper.querySelectorAll('.js-cart-product');

    this.promoCode = this.wrapper.querySelector('.js-cart-promo-code');
    this.promoCodeInput = this.promoCode && this.promoCode.querySelector('.js-cart-promo-code-input');
    this.promoCodeResult = this.promoCode && this.promoCode.querySelector('.js-cart-promo-code-result');

    this.registerEventHandlers();
  }

  registerEventHandlers() {
    Array.from(this.products).forEach((product) => {
      const spinnerInput = product.querySelector('.js-cart-product-spinner-input');
      const btnRemove = product.querySelector('.js-cart-product-btn-remove');
      const btnRestore = product.querySelector('.js-cart-product-btn-restore');

      let timeout;

      if (spinnerInput) {
        spinnerInput.addEventListener('change', () => {
          clearTimeout(timeout);
          timeout = setTimeout(async () => {
            await this.collectProductDataAndSend('add', product, spinnerInput.value);
          }, 300);
        });
      }

      btnRemove.addEventListener('click', async (e) => {
        e.preventDefault();
        if (product.classList.contains('disabled')) {
          this.view.removeDisabledProduct(product);
        } else {
          this.view.removeProduct(product);
          await this.collectProductDataAndSend('remove', product, spinnerInput.value);
        }
      });

      btnRestore.addEventListener('click', async (e) => {
        e.preventDefault();
        this.view.addProduct(product);
        await this.collectProductDataAndSend('cancelRemove', product, spinnerInput.value);
      });
    });

    if (this.promoCode) {
      this.promoCode.addEventListener('submit', async (event) => {
        event.preventDefault();

        const promoCodeValue = this.promoCodeInput.value;

        if (promoCodeValue !== '') {
          await this.collectPromoCodeDataAndSend('addCoupon', promoCodeValue);
        }
      });
    }

    if (this.promoCodeResult) {
      this.promoCodeResult.addEventListener('click', async (event) => {
        const btnRemove = event.target.closest('.js-cart-promo-code-btn-remove');

        if (btnRemove) {
          event.preventDefault();

          this.view.removePromoCode(btnRemove);
          await this.collectPromoCodeDataAndSend('removeCoupon', btnRemove.dataset.promoCodeValue);
        }
      });
    }
  }

  async collectProductDataAndSend(action, product, spinnerValue) {
    const data = {
      action,
      data: {
        quantity: spinnerValue,
        cartProductId: product.dataset.cartProductId,
        productId: product.dataset.productId,
      },
    };

    await this.sendDataAndUpdateWithNew(data);
  }

  async collectPromoCodeDataAndSend(action, promoCodeValue) {
    const data = {
      action,
      data: {
        coupon: promoCodeValue,
      },
    };

    await this.sendDataAndUpdateWithNew(data);
  }

  async sendDataAndUpdateWithNew(data) {
    const updatedData = await this.model.sendDataAndGetNew(data);

    if (updatedData) {
      this.view.updateData(updatedData);
    } else {
      this.view.clearPage();
    }
  }
}
